// pages/AgendaPage.js o donde desees usarlo
/*import React from 'react';
import { Box } from '@mui/material';
import AgendaCalendar from '../../components/administracion/calendar/AgendaCalendar';

const AgendaPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <AgendaCalendar
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de documentos:', newOrder);
                }}
            />
        </Box>
    );
};

export default AgendaPage;*/

// pages/agenda/AgendaPage.jsx
import React, { useMemo, useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import AgendaCalendarBase from '../../components/administracion/calendar/AgendaCalendarBase';

const TABS = [    
    {
        label: 'Externos',
        props: {
            serProInt: false,
            tipoServicioCodigo: 'TRANSPORTE_PERSONAL',
            title: 'Agenda de Manifiestos Externos',
            filterBadges: [{ label: 'Externos', color: 'default' }],
        },
    },
    {
        label: 'Internos',
        props: {
            serProInt: true,
            tipoServicioCodigo: 'TRANSPORTE_PERSONAL',
            title: 'Agenda de Manifiestos Internos',
            filterBadges: [{ label: 'Internos', color: 'primary' }],
        },
    },
    {
        label: 'Taxi',
        props: {
            serProInt: false,
            tipoServicioCodigo: 'TAXI',
            title: 'Agenda de Taxis',
            filterBadges: [{ label: 'Taxi', color: 'secondary' }],
        },
    },
    {
        label: 'Todos',
        props: {
            //serProInt: false,
            tipoServicioCodigo: 'TRANSPORTE_PERSONAL',
            title: 'Manifiestos Externos / Internos',
            filterBadges: [{ label: 'Todos', color: 'secondary' }],
        },
    },
];

const AgendaPage = () => {
    const [tab, setTab] = useState(0);
    const current = useMemo(() => TABS[tab], [tab]);

    return (
        <Box sx={{ p: 2 }}>
            <Paper elevation={0} sx={{ mb: 2, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
                <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="fullWidth">
                    {TABS.map((t) => <Tab key={t.label} label={t.label} />)}
                </Tabs>
            </Paper>

            {/* key fuerza remount y limpia estado al cambiar de pestaña */}
            <AgendaCalendarBase key={tab} {...current.props} />
        </Box>
    );
};

export default AgendaPage;


